import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';

import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
import { types as sdkTypes } from '../../../../util/sdkLoader';

import SectionContainer from '../SectionContainer';

import california from '../../../../assets/CALIFORNIA_AdobeStock_193151712.webp';
import Colorado from '../../../../assets/COLORADO_AdobeStock_256750697.webp';
import Florida from '../../../../assets/FLORIDA_AdobeStock_617018200.webp';
import Michigan from '../../../../assets/MICHIGAN_AdobeStock_163403945.webp';
import Utah from '../../../../assets/UTAH_AdobeStock_78608543.webp';
import Wyoming from '../../../../assets/wyoming.webp';
import Washington from '../../../../assets/about-us-hero-mountains.png';

import css from './Locations.module.css';

const { LatLng, LatLngBounds } = sdkTypes;

// Swiper CSS is browser-only; top-level import breaks Node SSR.

const data = [
  {
    id: 1,
    title: 'California',
    image: california,
    address: 'California, USA',
    bounds: new LatLngBounds(
      new LatLng(42.0095, -114.1312),
      new LatLng(32.5288, -124.4096)
    ),
  },
  {
    id: 2,
    title: 'Colorado',
    image: Colorado,
    address: 'Colorado, USA',
    bounds: new LatLngBounds(
      new LatLng(41.0034, -102.0415),
      new LatLng(36.9924, -109.0603)
    ),
  },
  {
    id: 3,
    title: 'Florida',
    image: Florida,
    address: 'Florida, USA',
    bounds: new LatLngBounds(
      new LatLng(31.0009, -79.9743),
      new LatLng(24.3963, -87.6349)
    ),
  },
  {
    id: 4,
    title: 'Michigan',
    image: Michigan,
    address: 'Michigan, USA',
    bounds: new LatLngBounds(
      new LatLng(48.3061, -82.123),
      new LatLng(41.6961, -90.4181)
    ),
  },
  {
    id: 5,
    title: 'Utah',
    image: Utah,
    address: 'Utah, USA',
    bounds: new LatLngBounds(
      new LatLng(42.0016, -109.0411),
      new LatLng(36.9979, -114.053)
    ),
  },
  {
    id: 6,
    title: 'Wyoming',
    image: Wyoming,
    address: 'Wyoming, USA',
    bounds: new LatLngBounds(
      new LatLng(45.0025, -104.0411),
      new LatLng(40.9979, -111.053)
    ),
  },
];

const LocationCard = ({ item }) => (
  <div className={css.location}>
    <img src={item.image} alt={item.title} />
    <h3 className={css.locationTitle}>{item.title}</h3>
    <Link to={item.to} className={css.locationLink}>
     →‎ ‎View Listings
    </Link>
  </div>
);

export default function Locations(props) {
  const { sectionId, className, rootClassName, appearance, options } = props;
  const routeConfiguration = useRouteConfiguration();

  useEffect(() => {
    import('swiper/css');
  }, []);

  const locationSlides = useMemo(
    () =>
      data.map(item => ({
        ...item,
        to: createResourceLocatorString('SearchPage', routeConfiguration, {}, {
          address: item.address,
          bounds: item.bounds,
        }),
      })),
    [routeConfiguration]
  );

  return (
    <SectionContainer
      id={sectionId}
      className={className || css.root}
      rootClassName={rootClassName}
      appearance={appearance}
      options={options}
      contentClassName={css.locationsSectionContent}
    >
      <div className={css.locations}>
        <div className={css.locationsHeader}>
          <h2 className={css.locationsHeaderTitle}>Explore by Location</h2>
          <div className={css.locationsHeaderButtonContainer}>
            <p>Browse outdoor gear shared by local communities in top adventure regions.</p>
            {/* <Link to="/listings" className={css.locationsButtonLink}>
              View All
            </Link> */}
          </div>
        </div>

        <div className={css.locationsGridWrap}>
          <div className={css.locationsList}>
            {locationSlides.map(item => (
              <LocationCard key={item.id} item={item} />
            ))}
          </div>
        </div>

        <div className={css.locationsSwiperWrap}>
          <Swiper
            className={css.swiper}
            modules={[FreeMode]}
            slidesPerView={1.5}
            spaceBetween={16}
            freeMode={{ enabled: true, momentumRatio: 0.85 }}
            grabCursor
            watchOverflow
          >
            {locationSlides.map(item => (
              <SwiperSlide key={item.id} className={css.swiperSlide}>
                <LocationCard item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/* <Link to="/listings" className={classNames(css.locationsButtonLink, css.locationsButtonLinkMobile)}>
            View All
        </Link> */}
      </div>
    </SectionContainer>
  );
}
